import { IntlShape } from 'react-intl';

import { QuantityViolation } from 'store/booking-add-ons/types';

/*
 * An unbounded product reports its maximum as Infinity, so the bound has to be named one-sidedly
 * rather than rendered into "between 3 and Infinity".
 */
export const quantityViolationText = (intl: IntlShape, violations: Array<QuantityViolation>): string =>
  [
    intl.formatMessage({ id: 'add_on_quantity_invalid' }),
    ...violations.map(({ name, min, max }) =>
      intl.formatMessage(
        { id: Number.isFinite(max) ? 'add_on_quantity_between' : 'add_on_quantity_at_least' },
        { name, min, max },
      ),
    ),
  ].join(' ');
